"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformOptions = exports.getSelectedOption = void 0;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

// TODO: clean up the anys

var transformOption = function transformOption(option, disabled) {
  if (disabled !== null && disabled !== void 0 ? disabled : option.disabled) {
    return _objectSpread(_objectSpread({}, option), {}, {
      isDisabled: true
    });
  }
  return option;
};
var transformOptions = exports.transformOptions = function transformOptions(options) {
  return options.filter(function (option) {
    if ("options" in option) {
      return true;
    }
    return !option.hidden;
  }).map(function (option) {
    if ("options" in option) {
      return _objectSpread(_objectSpread({}, option), {}, {
        options: option.options.filter(function (single) {
          return !single.hidden;
        }).map(function (single) {
          return transformOption(single, option.disabled);
        })
      });
    }
    return transformOption(option);
  });
};
var findByValue = function findByValue(normalizedOptions, value) {
  if (_typeof(value) === "object") {
    return value;
  }
  return normalizedOptions.find(function (option) {
    return option.value === value;
  });
};
var getSelectedOption = exports.getSelectedOption = function getSelectedOption(value, options) {
  var normalizedOptions = [];
  options.forEach(function (option) {
    if ("options" in option) {
      normalizedOptions.push.apply(normalizedOptions, _toConsumableArray(option.options));
    } else {
      normalizedOptions.push(option);
    }
  });
  if (Array.isArray(value)) {
    return value.map(function (val) {
      return findByValue(normalizedOptions, val);
    });
  }
  return findByValue(normalizedOptions, value);
};